import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class InspectionService {

  constructor( private httpService: HttpService) { }

    sampleEcsRecord(object) {

        var request = {
            URL: "inspection/ecsEntry",
            DATA: object
        }
        return this.httpService.post(request);

    }

    getRegisterDirector(object) {
        var registerList = {
            URL: "inspection/getBankDetails/5cee33d225242e023acfb2d4",
            DATA: object
        }
        return this.httpService.post(registerList);
    }

    getRegisterDirectorById(id) {
        var request = {
            URL: 'inspection/getBankDetailsById/' + id
        }
        return this.httpService.get(request);
    }

    updateInspection(object, id) {
        var request = {
            URL: "inspection/updateInspectionData/" + id,
            DATA: object
        }
        return this.httpService.post(request);
    }

    removeInspectionDetails(_id) {
        var request = {
            URL: "inspection/deleteInspectionDetails/" + _id
        }
        return this.httpService.get(request);
    }

    generateInspectionDocument(object) {
        var request = {
            URL: "inspection/generateInspectionDocument",
            DATA: object
        }
        return this.httpService.post(request);
    }

    downloadInspectionFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "inspection/downloadDocument/" + id+ "/" + type + "/" + token;
    }
    downloadInspectionPdfFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "inspection/downloadPdfDocument/" + id+ "/" + type + "/" + token;
    }
}